import React from 'react'
import { useIntl } from 'react-intl'

import IconButton from '../../../../LuxKit/Button/IconButton'
import LineTimesIcon from 'LuxKit/Icons/line/LineTimesIcon'

interface Props extends Omit<React.ComponentProps<typeof IconButton>, 'kind' | 'children'> {
  size?: React.ComponentProps<typeof IconButton>['size']
  variant?: React.ComponentProps<typeof IconButton>['variant']
}

function CloseButton({ size = 'small', variant = 'dark', ...props }: Props) {
  const intl = useIntl()
  return <IconButton
    kind="tertiary"
    aria-label={intl.formatMessage({
      id: 'mNe2viA+Iz',
      defaultMessage: 'Close',
      description: 'Accessible aria-label for the close button to dismiss the current dialog or panel',
    })}
    {...props}
    data-testid="close-banner-button"
    size={size}
    variant={variant}
  >
    <LineTimesIcon />
  </IconButton>
}

export default CloseButton
